import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';
import emailEditingIcon from '../../images/email-editing.svg';

export function EmailPaywallBanner() {
  const history = useHistory();

  function handleUnlockAccess() {
    const previousUrl = window.location.href;
    history.push({
      pathname: '/subscriptions',
      state: {
        url: previousUrl,
        data: {
          navigatedToSubscriptions: true,
        },
      },
    });
  }

  return (
    <div className="flex flex-row items-center gap-4 mt-4 p-5 rounded-lg bg-grey-100">
      <img src={emailEditingIcon} alt="" className="shrink-0 h-[46px] w-auto" />
      <div className="flex-1 flex flex-col gap-2">
        <Typography variant="body2" className="font-bold text-grey-900">
          Upgrade to write longer messages!
        </Typography>
        <Typography variant="caption" className="text-grey-700">
          Hit send without limits. Upgrade for full access to DigiSign.
        </Typography>
      </div>
      <Button variant="contained" color="primary" onClick={handleUnlockAccess}>
        Unlock Access
      </Button>
    </div>
  );
}
